import { useContext } from 'react';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import {Handle, Position, useReactFlow } from "@xyflow/react";
import SettingsIcon from '@mui/icons-material/Settings';
import CheckIcon from "@mui/icons-material/Check";

function WorkflowScraperNode({ id, data }) {
    const context = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();

    function handleScraperConfigurationClick() {
        let node = reactFlowInstance.getNode(id);
        context.setActiveEditScraperNode(node);
    }

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }

    return (
        <div className={ "workflow-node scraper " + id + " " + (successfulTest()) }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            <Handle type="target" id="scraper-node-target" position={Position.Top} >
                <span className="handle-label top" >{ "Input" }</span>
            </Handle>
            <Handle type="target" id="scraper-node-target-left" position={Position.Left} >
                <span className="handle-label left" >{ "Input" }</span>
            </Handle>
            <div className="node__layout scraper">
                <div className="layout__top">
                    <span className="scraper-icon" title="Scraper Node" />
                    <span className={ "label-span" }>
                        { (typeof data?.label === 'string' && data.label.length > 0) ? data.label : 'Web Scraper Node' }
                    </span>
                </div>
                <div className="layout__bottom">

                    <span className="action-span nodrag" onClick={ handleScraperConfigurationClick }>
                        <SettingsIcon />
                    </span>
                </div>
            </div>
            <Handle type="source" id="scraper-node-source" position={Position.Bottom} >
                <span className="handle-label bottom" >{ "Output" }</span>
            </Handle>
        </div>
    );
}

export default WorkflowScraperNode;